import FlowCommon from "../lib/FlowCommon";

const setContextPad = (lf) => {
  const userConfig = {
    type: "user",
    label: "用户任务",
    icon:require("../background/user.png"),
    properties: FlowCommon.getNodeDefaultConfig('user').properties
  };
  const serviceConfig = {
    type: "setting",
    label: "系统任务",
    icon:require("../background/setting.png"),
    properties: FlowCommon.getNodeDefaultConfig('setting').properties
  };
  const exclusiveGatewayConfig = {
    type: "exclusiveGateway",
    label: "条件判断",
    icon: require("../background/exclusiveGateway.png"),
    properties: FlowCommon.getNodeDefaultConfig('exclusiveGateway').properties
  };
  const endConfig = {
    type: "end",
    label: "结束",
    icon:require("../background/end.png"),
    properties: FlowCommon.getNodeDefaultConfig('end').properties
  };
  const deleteConfig = {
    icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAUpJREFUWEftVzuywjAMlKgDPV2g4RYPuAnfDs7w4AzQ8b0Jn1vQQDp6SI0YFwFPSMC2EiYZnDLZldYrybERGI/XLs4Aofc2BMHcXV37pmnQlOh1SwMgmijxEYfu4jJVwoZARgKPXeevQLjTSXhDqlcX/l6HI7APgaeOM0LCulIAhDIA1JSwT9ABCM4qHELaVZb+6FUg4L9KgLQxBDTOqUDVEqdsYWSJU85pHN5oio2zGRDzK/DUchpYwI3BorUpdKNmZe1vo4ixDlqBkl2JOCiCaNfuDUFun0QEustrogPldYoU6P9dgWKQ5CoGkxj3XsZ+xcG4JOEdIKo9rEBRLuugfKIOb1mcPuJwwzqUf3U6jW4FCps5LnC4tsRc962D1sGgBziTyOHaHsxUD2b+wMq5RH3lwJopgZm/dnLc+sRN5Nr5KQnne64F3gEyDFZHJCakvQAAAABJRU5ErkJggg==",
    callback: (data) => {
      lf.deleteElement(data.id);
      lf.extension.contextPad.hideContextMenu();
    }
  };
  lf.extension.contextPad.setContextMenuItems([deleteConfig]);
  lf.extension.contextPad.setContextMenuByType("start", [
    userConfig,
    serviceConfig,
    exclusiveGatewayConfig
  ]);
  lf.extension.contextPad.setContextMenuByType("user", [
    userConfig,
    serviceConfig,
    exclusiveGatewayConfig,
    endConfig
  ]);
  lf.extension.contextPad.setContextMenuByType("setting", [
    userConfig,
    serviceConfig,
    exclusiveGatewayConfig,
    endConfig
  ]);
  lf.extension.contextPad.setContextMenuByType("exclusiveGateway", [
    userConfig,
    serviceConfig
  ]);
};

export default setContextPad;



// WEBPACK FOOTER //
// ./src/components/Admin/Flow/bpmn/pad/setContextPad.js